<template>
<div class="chapter">
<div class="inner_page">
<p class="p4">For Tom and Sue. This novel has been a long time in the making. Thank you both for your patience and encouragement. Without it, I doubt I would have got this far.</p>
<p> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?223302f0